import { render, staticRenderFns } from "./intOrder.vue?vue&type=template&id=2ca186f0&scoped=true"
import script from "./intOrder.vue?vue&type=script&lang=js"
export * from "./intOrder.vue?vue&type=script&lang=js"
import style0 from "./intOrder.vue?vue&type=style&index=0&id=2ca186f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca186f0",
  null
  
)

export default component.exports